<template>
    <div>
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <ion-input placeholder="Email" type="email" shape="round" expand="full" v-on:ionInput="setEmail($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                <ion-input placeholder="Password" type="password" shape="round" expand="full" v-on:ionInput="setPassword($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                <ion-input placeholder="Password (confirm)" type="password" shape="round" expand="full" v-on:ionInput="setPassword2($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>

                <ion-button shape="round" expand="full" v-on:click="resetPassword()" style='margin-bottom: 12px;'>Reset Password</ion-button>
                <div class="router-nav">
                    <router-link to="/login">Login</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import _ from 'lodash';
import Logo from '@/components/Logo.vue'
import {alerts} from '../../mixins/alerts';

export default {
    name: 'passwordreset',
    data : function () {
        return {
            email : '',
            password : '',
            password2 : ''
        }
    },
    components: {
        Logo
    },
    mixins : [alerts],
    methods : {
        setEmail : function (event) {
            this.email = event.target.value;
        },
        setPassword : function (event) {
            this.password = event.target.value;
        },
        setPassword2 : function (event) {
            this.password2 = event.target.value;
        },
        validateEmail : function (email) {
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,12})+$/.test(email)) {
                return true;
            }
            return false;
        },
        resetPassword : function () {
            let self = this;
            if (!this.validateEmail(this.email)) {
                this.showError('Please enter a valid email address');
                return;
            }
            if (_.size(this.password) < 7) {
                this.showError('Your password must be at least 7 characters');
                return;
            }
            if (this.password != this.password2) {
                this.showError('Your password confirmation does not match.');
                return;
            }
            let params = {
                email            : this.email,
                password         : this.password,
                password_confirm : this.password2,
                token            : this.$route.params.token
            };
            this.axios.post(this.api + 'auth/password', params)  // eslint-disable-next-line
                .then(response => {
                    self.showSuccess('We have received your request. Your password was reset, and you can now login using your new password.', function () {
                        self.$router.push({name : 'login'});
                    });
                })
                .catch(error => {
                    console.error('error resetting password', error);
                    self.showError('There was a problem resetting your password.  Are you sure that\'s the right email address?');
                });
        }
    }
}
</script>
